<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/"></router-link>
      <router-link to="/Home"></router-link>
    </div> -->
    <transition :name="transitionName">
      <!-- include属性表示只有name属性的组件会被缓存 -->
      <!-- <keep-alive :max="60" :exclude="['login','faultDiaresPage','xlDiaresPage','xlDetialsPage','changeUserPage','changeFacePage','myPage','FHQXPage','FHListPage','SOEPage','BHDZPage','XSJLPage']"> -->
        <keep-alive :include="['home','tjPage','xlPage','getMlinesPage','xlDiaresPage','faultDetialsPage','mlineDiaresPage']">
          <router-view/>
        </keep-alive>
    </transition>
    <!-- <transition :name="transitionName">
        <keep-alive :max="60" :include="['home','faultPage','getCollectMlinesPage','getDayDiaresPage','getMlinesPage','myPage']">
          <router-view/>
        </keep-alive>
    </transition> -->
    <van-notify v-model="show"  background="transparent" color="#353535" className="home">
      <div class="item xltj">
        <h3>xxx线路名称名称2-速断故障</h3>
        <p>2021/1/10 08:00:25xxxxx线路名称发生接地故障，故障区段在南湖支线#2与南湖支线#14之间。</p>
      </div>
    </van-notify>
  </div>
</template>
<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Notify } from 'vant'

Vue.use(Tabbar, TabbarItem, Notify)

export default {
  name: 'app',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Notify.Component.name]: Notify.Component
  },
  watch: {
    // 使用watch 监听$router的变化
    $route (to, from) {
      if (to.name === 'faultPage' || to.name === 'xlPage' || to.name === 'myPage') {
        this.transitionName = 'fold-right'
      } else if (to.name === 'Guide') {
        this.transitionName = ''
      } else if (from.name === 'faultDiaresPage' && to.name === 'faultPage') {
        this.transitionName = 'fold-right'// 返回效果
      } else if (from.name === 'deviceStatusPage' && to.name === 'faultDiaresPage') {
        this.transitionName = 'fold-right'// 返回效果
      } else if ((from.name === 'mlineContactPage' && to.name === 'xlDiaresPage')||(from.name === 'FHQXPage' && to.name === 'faultDetialsPage')||(from.name === 'FHListPage' && to.name === 'faultDetialsPage')) {
        this.transitionName = 'fold-right'// 返回效果
      }  else if (to.name === 'FHQXPage'||to.name === 'FHListPage') {
        this.transitionName = 'fold-left'
      } else {
        this.transitionName = 'fold-left'// 进入效果
      }
    }

  },
  beforeDestroy () {
    if (localStorage.getItem('UserToken') === null) {
      clearInterval(this.timer)// 清除定时器
      this.timer = null
      // this.closeAllNotification()
    }
  },
  mounted () {
    // this.messageStatus = this.$root.messageStatus
    // if (localStorage.getItem('UserToken') !== null) {
    //   // 登录了才执行
    //   // 请求消息通知查询接口
    //   this.util.post('/getMessageStatus').then(({ data }) => {
    //     if (data.code === 200) {
    //       this.$root.messageStatus = data.data.messageStatus
    //       localStorage.setItem('messageStatus', data.data.messageStatus) // 存储消息通知状态 0关 1开
    //       if (this.$root.messageStatus === 0) {
    //       // 关闭通知
    //         clearInterval(this.timer)// 清除定时器
    //         this.timer = null
    //         this.show = false
    //       } else {
    //       // 开启通知
    //         this.showNotify()
    //         this.timer = setInterval(() => {
    //           this.showNotify()// 显示实时故障
    //         }, 10000)// 隔10秒刷一次
    //       }
    //     } else {
    //     // this.$router.replace({
    //     //   path: '/login'// 进入登录页
    //     // })
    //       return Promise.reject(new Error(data.msg || '系统错误，请稍后再试。'))
    //     }
    //   })
    // }
  },
  created () {

  },
  methods: {
    showNotify () {
      this.show = false// 应该为true
      setTimeout(() => {
        this.show = false
      }, 5000)
    }
  },
  computed: {},
  data () {
    return {
      // isRouterAlive: true, // 控制视图是否显示的变量
      transitionName: 'fold-left',
      messageStatus: '', // 消息通知状态 0关 1开
      show: false,
      timer: null // 定时器名称
    }
  }
}
</script>

<style lang="less">
// @font-face {
//   font-family: myFirstFont;
//   src: url('fonts/PingFang Regular.ttf')
// }

#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  background: #F8FAFB;
  font-size:14px;
}
#nav {
  padding: 30px;
  display: none;
  a {
    font-weight: bold;
    color: #EFF7FA;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
// .home{margin-top: 15px;}
.home .item{text-align: left;}
.fold-left-enter-active {
  width:100vw;
  height: 100vh;
    animation-name: fold-left-in;
    animation-duration: .15s;
    position: fixed;
    top: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000;
    perspective: 1000;
  }
  .fold-left-leave-active {
    width:100vw;
    height: 100vh;
    animation-name: fold-left-out;
    animation-duration: .15s;
    position: fixed;
    top: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000;
    perspective: 1000;
  }
  @keyframes fold-left-in {
    0% {
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
      /* visibility: visible; */
    }
    /*50% {
      transform: translate3d(50%, 0, 0);
    }*/
    100% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes fold-left-out {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    /*50% {
      transform: translate3d(-50%, 0 , 0);
    }*/
    100% {
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
      /* visibility: hidden; */
    }
  }
  .fold-right-enter-active {
    width:100vw;
    height: 100vh;
    animation-name: fold-right-in;
    animation-duration: .15s;
     position: fixed;
    top: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000;
    perspective: 1000;
  }
  .fold-right-leave-active {
    width:100vw;
    height: 100vh;
    animation-name: fold-right-out;
    animation-duration:.15s;
     position: fixed;
    top: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000;
    perspective: 1000;
  }
  @keyframes fold-right-in{
    0% {
      width: 100%;
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
      /* visibility: visible; */
    }
    /*50% {
      transform: translate3d(50%, 0, 0);
    }*/
    100% {
      width: 100%;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes fold-right-out  {
    0% {
      width: 100%;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    /*50% {
      transform: translate3d(-50%, 0 , 0);
    }*/
    100% {
      width: 100%;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
      /* visibility: hidden; */
    }
  }

</style>
